'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { getTeamLeadTeamIdsFromTeams } from '@workspace/ui/lib';
import { useAuthStore } from '@/stores/authStore';

export interface TeamRolesInfo {
  hasRole: (roleName: string) => boolean;
  teamLeadId: number | undefined;
  teamLeadTeamIds: number[];
}

/**
 * Reactive hook for team roles info from the auth store (client-side only).
 */
export function useTeamRoles(): TeamRolesInfo {
  const user = useAuthStore((state) => state.user);
  const teams = user?.teams ?? [];
  const teamLeadTeamIds = getTeamLeadTeamIdsFromTeams(teams);
  const teamLeadId = teamLeadTeamIds[0];

  function hasRole(roleName: string): boolean {
    return teams.some((team) => (team.team_role ?? []).includes(roleName));
  }

  return {
    hasRole,
    teamLeadId,
    teamLeadTeamIds,
  };
}
